module.exports = __webpack_public_path__ + "img/27_82.60c92aea.png";